import type { Ref } from 'vue';
import type { Element as ElementType, PageOptions } from '@shared/types/model';
import type { ElementTypes, GeneralTextOptions } from '@shared/types/options';

export function getGeneralTextOptions({ element, pageOptions, optionKeys }: { element: Ref<ElementType<ElementTypes>>; pageOptions: Ref<PageOptions>; optionKeys?: string[]; }) {

  const keys = optionKeys || [];
  const elOptions = element.value.options as Record<string, any>;
  const reducedObj = keys.reduce((acc, key) => {
    const options = elOptions[key] as GeneralTextOptions;
    const textStyle = {
      bold: options.textStyle?.bold ? 600 : '',
      italic: options.textStyle?.italic ? 'italic' : '',
      underline: options.textStyle?.underline ? 'underline' : '',
      strikeThrough: options.textStyle?.strikeThrough ? 'line-through' : ''
    }
    const color = options.colors?.regular || pageOptions.value.colors?.text?.[0];
    const result = {
      color,
      fontFamily: options.fontFamily || pageOptions.value.fontFamily,
      fontSize: `${options.fontSize || 14}px`,
      fontWeight: textStyle?.bold || 400,
      fontStyle: textStyle?.italic || 'inherit',
      textDecoration: `${textStyle?.underline} ${textStyle?.strikeThrough}`.trim()
    }
    acc[key] = result;
    return acc;
  }, {} as Record<string, any>);

  return reducedObj;
}
